import React from 'react'
import FooterThree from '../../footer/FooterThree';
import HeaderThree from '../../header/HeaderThree';
import SliderThree from './SliderThree'
import AboutArea from './AboutArea'
import GameGallery from './GameGallery'
import MatchArea from './MatchArea'
import Donation from './Donation'
import TeamArea from './TeamArea'
import ContactArea from './ContactArea'
import Brand from './Brand'
import SliderArea from './SliderArea';
import NewGamesArea from './NewGamesArea';
import BlogArea from './BlogArea';




function IndexThree() {
  return (
	  <>
	  	{/* header-area */}
      		<HeaderThree/>
        {/* header-area-end */}
        {/* main-area */}
        <main>
          {/* slider-area */}
			<SliderArea/>

			<NewGamesArea/>
			
            {/* <Donation/> */}
			<BlogArea/>
            
          	<AboutArea/>




			
          	{/* <GameGallery/> */}
         	{/* <MatchArea/> */}
         	{/* <TeamArea/> */}
        	{/* <ContactArea/> */}
         	{/* <Brand/> */}

        </main>

			<FooterThree/>
		</>
		
  )
}

export default IndexThree